import React from "react";
import { Container, Image, Row, Col } from "react-bootstrap";
import { ABOUT_US_BUDGET_DESCRIPTION, ABOUT_US_BUDGET_TITLE, ABOUT_US_EXPERIENCE_DESCRIPTION, ABOUT_US_EXPERIENCE_TITLE, ABOUT_US_P1, ABOUT_US_P2, ABOUT_US_SERVICES_DESCRIPTION, ABOUT_US_SERVICES_TITLE, ABOUT_US_TEAM_DESCRIPTION, ABOUT_US_TEAM_TITLE, ABOUT_US_TITLE, FOCUS_ON_ACHIEVEMENTS_DESCRIPTION, FOCUS_ON_ACHIEVEMENTS_QUOTE, FOCUS_ON_ACHIEVEMENTS_TITLE } from "../Contexts/config";

export const AboutUs = ({lang}) => {



    return (
        <Container style={{paddingTop: 30}} id="about">
            <Row className="justify-content-center align-items-center">
                <Col lg={6}>
                    <Image src="assets/logo-plain.png" alt="" fluid />
                </Col>
                <Col lg={6}>
                    <h1 className="text-center"><i>{ABOUT_US_TITLE[lang]}</i></h1>
                    <p className="lead p-3">{ABOUT_US_P1[lang]}</p>
                    <p className="lead p-3">{ABOUT_US_P2[lang]}</p>
                </Col>
            </Row>
            {/*<h1 className="text-center"><i>{ABOUT_US_TITLE[lang]}</i></h1>*/}
            {/*<Row className="justify-content-center text-center">*/}
            {/*    <Col lg={6}>*/}
            {/*        <p className="lead p-3">{ABOUT_US_P1[lang]}</p>*/}
            {/*        <p className="lead p-3">{ABOUT_US_P2[lang]}</p>*/}
            {/*    </Col>*/}
            {/*</Row>*/}
            <Row className="mt-5 border-bottom pb-3">
                <Col lg className="text-center">
                    <Image width={150} fluid src="assets/experience.svg" alt="" className="p-3" />
                    <h3>{ABOUT_US_EXPERIENCE_TITLE[lang]}</h3>
                    <p className="lead">{ABOUT_US_EXPERIENCE_DESCRIPTION[lang]}</p>
                </Col>
                <Col lg className="text-center">
                    <Image width={150} fluid src="assets/service.svg" alt="" className="p-3" />
                    <h3>{ABOUT_US_SERVICES_TITLE[lang]}</h3>
                    <p className="lead">{ABOUT_US_SERVICES_DESCRIPTION[lang]}</p>
                </Col>
                <Col lg className="text-center">
                    <Image width={150} fluid src="assets/team.svg" alt="" className="p-3" />
                    <h3>{ABOUT_US_TEAM_TITLE[lang]}</h3>
                    <p className="lead">{ABOUT_US_TEAM_DESCRIPTION[lang]}</p>
                </Col>
                <Col lg className="text-center">
                    <Image width={150} fluid src="assets/budget.svg" alt="" className="p-3" />
                    <h3>{ABOUT_US_BUDGET_TITLE[lang]}</h3>
                    <p className="lead">{ABOUT_US_BUDGET_DESCRIPTION[lang]}</p>
                </Col>
            </Row>
            <div class="d-md-flex align-items-center justify-content-between">
                {/*<div class="col-md-6 p-4">*/}
                {/*    <Image src="assets/achievements.jpg" alt="" fluid/>*/}
                {/*</div>*/}
                <div>
                    <h1>{FOCUS_ON_ACHIEVEMENTS_TITLE[lang]}</h1>
                    <p className="lead">{FOCUS_ON_ACHIEVEMENTS_DESCRIPTION[lang]}</p>
                    <blockquote className="blockquote border-warning border-start p-2 mt-5">
                        <p className="font-monospace text-white">{FOCUS_ON_ACHIEVEMENTS_QUOTE[lang]}</p>
                    </blockquote>
                </div>
            </div>
        </Container>
    );
}